import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthProvider";

export interface AuthorizedRouteProps {
    redirect?: string;
    component: JSX.Element;
}

export function AuthorizedRoute(props: AuthorizedRouteProps): JSX.Element {
  const { defaultAuthorizedRouteRedirect, user } = useAuth();
  const location = useLocation();
  
  if (user === false) {
    return <Navigate to={props.redirect ?? defaultAuthorizedRouteRedirect} state={{returnUrl: location?.pathname}} />
  } else {
    return props.component
  }
}
